import { Directive, EventEmitter, Input, Output } from '@angular/core';

import { ImmomioIconName } from '../../models';

/**
 * Interactive single-select filter chip (ART-19551).
 *
 * Deliberately separate from `ChipBaseComponent`, which is a non-interactive
 * uppercase badge with no icon, no selected state and no output.
 */
@Directive()
export abstract class SelectableChipBaseComponent {
  @Input() text: string;
  @Input() icon?: ImmomioIconName | null;
  @Input() selected = false;
  @Input() disabled = false;
  @Output() tapped = new EventEmitter<void>();

  public onTap(): void {
    if (this.disabled) {
      return;
    }
    this.tapped.emit();
  }
}
